import { LucideShieldAlert, LucideMail } from "lucide-react";
import { Modal, ModalBody, ModalFooter } from "@/components/modals/Modal";
import { Button } from "@/components/ui/button";

/**
 * Shown whenever the backend returns { limitExceeded: true }.
 * Passes the backend's message through verbatim (it already says the specific limit)
 * and gives the user a direct path to contact support.
 */
export function LimitExceededModal({ open, onClose, message, zIndex = 50 }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Limit Reached"
      subtitle="EasyReports has built-in limits to keep things running smoothly for everyone."
      icon={<LucideShieldAlert size={16} className="text-warning" />}
      maxWidth="max-w-md"
      zIndex={zIndex}
    >
      <ModalBody className="space-y-4">
        <div className="rounded-xl border border-warning-border bg-warning-bg px-4 py-3.5">
          <p className="text-sm text-foreground leading-relaxed font-medium">
            {message}
          </p>
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed">
          If you need a higher limit for your Report Folder or school, our team is happy
          to review your request. Get in touch and we&apos;ll sort it out.
        </p>
      </ModalBody>
      <ModalFooter>
        <a href="mailto:support@easyreports.ca" className="flex-1">
          <Button className="w-full gap-2">
            <LucideMail size={14} />
            Contact Support
          </Button>
        </a>
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
